import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api, { cacheGet, cacheSet, listFrom } from '../api';

const COLORS = ['#22C55E', '#EF4444', '#06B6D4', '#F97316', '#A855F7', '#3B82F6'];

export default function Collection() {
  const [cats, setCats] = useState(() => cacheGet('collection', []));

  async function load() {
    try {
      const { data } = await api.get('/collection');
      const list = listFrom(data, 'categories');
      setCats(list);
      cacheSet('collection', list);
    } catch (err) {
      toast.error('Ошибка загрузки');
      throw err;
    }
  }

  useEffect(() => { load().catch(() => {}); }, []);

  async function resetStats() {
    try {
      await api.post('/collection/reset-stats');
      toast.success('Статистика сброшена');
      load();
    } catch {
      toast.error('Не удалось сбросить статистику');
    }
  }

  async function restore() {
    try {
      await api.post('/collection/restore-defaults');
      toast.success('Стандартный сбор восстановлен');
      load();
    } catch {
      toast.error('Не удалось восстановить сбор');
    }
  }

  async function remove(id) {
    // categories aren't deleted via rules endpoint — skip hard delete if unsupported
    toast('Редактирование категории — внутри правил');
  }

  return (
    <div>
      <div className="rm-page-title">
        <span style={{ color: '#F97316' }}>⚡</span> Управление сбором
      </div>
      <div className="rm-help">
        <b>Помощь</b>
        Изменение порядка или правил автоматически сбрасывает статистику.
        Справа — процент отстука. Рекомендуем сбрасывать статистику после чистки или перед новым проливом.
      </div>

      <div className="rm-toolbar">
        <span className="rm-badge">{cats.length} правил всего</span>
        <div className="rm-actions">
          <button type="button" className="rm-btn danger" onClick={resetStats}>Сбросить статистику</button>
          <button type="button" className="rm-btn ghost" onClick={restore}>Восстановить стандартный сбор</button>
        </div>
      </div>

      <div className="rm-rule-list">
        {cats.map((c, i) => (
          <div className="rm-rule" key={c.id}>
            <span className="handle">⋮⋮</span>
            <div className="ico" style={{ background: COLORS[i % COLORS.length] }}>{(c.name || '?')[0]}</div>
            <div className="meta">
              <b>{c.name}</b>
              <span>Правил: {c.rules_count ?? 0} • Процент отстука: {(c.hit_pct ?? 0).toFixed(2)}%</span>
            </div>
            <div className="ops">
              <Link className="rm-icon-btn" to={`/collection/${c.id}`} title="Редактировать">✎</Link>
              <button type="button" className="rm-icon-btn danger" onClick={() => remove(c.id)}>🗑</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
